import { Map as IMap } from 'immutable';



export const CART_STATUS = {
    INVALID: 'invalid',
    PROCESSING: 'processing',
    READY: 'ready'
};


export const SET_CART_STATUS = '@@storefront/SET_CART_STATUS';

const initialState = IMap();


export default function cartReducer(state = initialState, action) {
    switch (action.type) {
        case SET_CART_STATUS:
            return state.set('cartStatus', action.status);
        default:
            return state;
    }
}




export function setCartStatusProcessing() {
    return {
        type: SET_CART_STATUS,
        status: CART_STATUS.PROCESSING
    };
}


export function setCartStatusInvalid() {
    return {
        type: SET_CART_STATUS,
        status: CART_STATUS.INVALID
    };
}


export function setCartStatusReady() {
    return {
        type: SET_CART_STATUS,
        status: CART_STATUS.READY
    };
}
